import React from 'react';
import {
    Modal, ModalOverlay, ModalContent, ModalHeader,
    ModalBody, ModalFooter, Button, Text, Box, Icon, VStack
} from '@chakra-ui/react';
import { MdLocationOn } from 'react-icons/md';

const GPSDisclosureModal = ({ isOpen, onAccept, onDecline }) => {
    return (
        <Modal isOpen={isOpen} onClose={onDecline} isCentered closeOnOverlayClick={false}>
            <ModalOverlay backdropFilter="blur(4px)" />
            <ModalContent mx={4} borderRadius="xl">
                <ModalHeader display="flex" alignItems="center" pb={0} pt={6}>
                    <Icon as={MdLocationOn} color="blue.500" boxSize={6} mr={2} />
                    定位權限說明
                </ModalHeader>
                <ModalBody py={6}>
                    <VStack align="stretch" spacing={4}>
                        <Text fontWeight="bold" fontSize="lg" color="gray.800">
                            天籟接送系統需要收集您的位置數據：
                        </Text>
                        <Text fontSize="md" color="gray.700" lineHeight="1.6">
                            當您啟動「我已出發」功能後，本 App 會在 **App 已關閉或未在使用中** 的狀態下，仍持續收集並傳送您的位置數據。
                        </Text>
                        <Box p={4} bg="blue.50" borderRadius="lg" borderLeft="4px solid" borderColor="blue.400">
                            <Text fontSize="sm" color="blue.800" fontWeight="medium">
                                目的：為了在您接近補習班時，自動通知老師準備學生的接送工作、顯示接送狀態與預估到達時間，確保學生安全並縮短等待時間。
                            </Text>
                        </Box>
                        <Text fontSize="xs" color="gray.500">
                            ※ 您可以隨時在裝置系統設定中撤銷此權限，但接送定位功能可能因此無法正常使用。
                        </Text>
                    </VStack>
                </ModalBody>
                <ModalFooter pb={6}>
                    <Button variant="ghost" mr={3} onClick={onDecline} color="gray.600">
                        暫不開啟
                    </Button>
                    <Button colorScheme="blue" onClick={onAccept} px={8} shadow="md">
                        我知道了，繼續
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default GPSDisclosureModal;
